"use strict";

/**
 * @classdesc
 * Entfernt einen Layer von seinem Elterngruppenlayer.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.layer.GCAbstractLayer} options.layer Zu entfernender Layer
 */
gc.gis.action.layer.RemoveLayer = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	/**
	 * @inheritdoc
	 */
	this.func = this.doExecute;
	/**
	 * @inheritdoc
	 */
	this.args = [options.layer];
};
gc.gis.action.layer.RemoveLayer.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * Entfernt den übergebenen Layer von seinem Elterngruppenlayer, sofern
 * vorhanden.
 * <em>Hinweis: Diese Funktion sollte nicht manuell aufgerufen werden.</em>
 *
 * @public
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @see gc.gis.action.GCAbstractAction#execute
 */
gc.gis.action.layer.RemoveLayer.prototype.doExecute = function( layer )
{
	var container = layer.getParent();
	if( container )
	{
		container.removeLayer( layer );
	}
};

